import React from 'react';
import BasicAlert from './BasicAlert';
import './styles.scss';

const ErrorAlert = ({ title, text, iconDisplay, shrink = false }) => (
    <BasicAlert
        text={text}
        icon={iconDisplay ? 'error' : null}
        type={'error'}
        title={title}
        shrink={shrink}
    />
);

export default ErrorAlert;
